module.exports = __webpack_public_path__ + "img/color-w-2@2x.195a0f0.webp";